export default "__VITE_ASSET__55ab962f__"